import axios from "axios";
import moment from "moment/moment";
import React, { useCallback, useEffect, useMemo, useReducer, useState } from "react";
import { IoInformationCircleOutline, IoRefresh } from "react-icons/io5";
import { IoMdRefresh } from "react-icons/io";
import Swal from "sweetalert2";
import { FadeLoader } from "react-spinners";
import { FaCross } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { ResendModal } from "./Tab2Components/ResendModal";
import FundDetailsModal from "./FundDetailsModal";
import { Alert, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import socket from "../../../context/socket";
import { formatRupees } from "../../../utils/inputsValidation";
import api from "../../../utils/api";
import { useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import { ReferAFriendModal } from "./modals/ReferAFriendModal";
import { TfiReload } from "react-icons/tfi";

export const Tab2 = ({ roomId, isViewArchivedEvent }) => {
  const {
    clientData,
    loading: clientLoading,
    error: clientError,
  } = useSelector((state) => state.client);
  const [initiatedFolios, setInitiatedFolios] = useState([]); // Default to an empty array
  const [selectAll, setSelectAll] = useState(true);
  // console.log("initiatedFolios", initiatedFolios, isViewArchivedEvent, clientData);
  console.log("selectAll", selectAll, initiatedFolios);
  const [showReferFriendModal, setShowReferFriendModal] = useState(false);


  const [goalEventId, setGoalEventId] = useState(null);
  const [isPostponed, setIsPostponed] = useState(false);
  const [sipStart, setSipStart] = useState(null);
  const [sipStartTotal, setSipStartTotal] = useState(0);
  const [isEventId, setIsEventId] = useState("");

  const [lumpsumAmountTotal, setLumpsumAmountTotal] = useState(0);

  const [sipStopTotal, setSipStopTotal] = useState(0);
  const [redeemAmountTotal, setRedeemAmountTotal] = useState(0);
  const [stpAmountTotal, setStpAmountTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  const [goalName, setGoalName] = useState(null);
  const [archivable, setArchivable] = useState(true);
  const [showResendModal, setShowResendModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [regeneratingId, setRegeneratingId] = useState(null);
  const navigate = useNavigate();
  // Define if not imported
  const groupByGoal = (folios) => {
    return folios.reduce((acc, folio) => {
      const goal = folio.goal_name || "Unmapped Folio";
      if (!acc[goal]) acc[goal] = [];
      acc[goal].push(folio);
      return acc;
    }, {});
  };

  const groupedFolios = useMemo(
    () => groupByGoal(initiatedFolios),
    [initiatedFolios]
  );

  const [groupedFoliosState, setGroupedFoliosState] = useState({});

  useEffect(() => {
    if (!groupedFolios || Object.keys(groupedFolios).length === 0) return;

    const copied = {};
    Object.entries(groupedFolios).forEach(([goal, folios]) => {
      copied[goal] = folios.map((f) => ({
        ...f,
        isChecked: f.isChecked || false,
      }));
    });

    setGroupedFoliosState(copied);
  }, [groupedFolios]);

  useEffect(() => {

    socket.on("execute", (msg) => {
      console.log("✅ Received Execute Data:", msg);

      if (msg?.message === "kyc-Required") {
        console.log("✅ Received Execute Data:", "navigate done ");

        Swal.fire({
          title: 'KYC Required',
          text: 'Check the KYC Status before executing any transaction.',
          icon: 'warning',
          // confirmButtonText: 'Click here to check KYC Status',
          confirmButtonText: 'OK',
          allowOutsideClick: false
        }).then((result) => {
          if (result.isConfirmed) {

            // const nextUrl = `/what-we-will-need-from-you/?clientId=${roomId}`;
            // socket.emit("navigate", { room: roomId, url: nextUrl });
            // navigate(nextUrl);
          }
        });
      }
      if (msg?.data?.success == true) {
        console.log("✅ Received Execute Data:", "navigate done aur ye bhi  ");

        // const nextUrl = `/refer-friends/?clientId=${roomId}`;
        // socket.emit("navigate", { room: roomId, url: nextUrl });
        // navigate(nextUrl);
        setShowReferFriendModal(true)



        // getInitiatedFolios();
      }
      console.log("Transaction Data:", msg.data, msg, msg?.data?.success);
    });

    // Cleanup on unmount
    return () => {
      socket.off("execute");
    };
  }, []);



  const [totals, setTotals] = useState({
    totalAmount: 0,
    sipStart: 0,
    sipStop: 0,
    stpAmount: 0,
    redeemAmount: 0,
    lumpsumAmount: 0,
    sipStartTotal: 0,
    stpAmountTotal: 0,
    sipStopTotal: 0,
    redeemAmountTotal: 0,
    lumpsumAmountTotal: 0,
  });
  const [archivedEvent, setArchivedEvent] = useState(null);
  console.log("archivedEvent", archivedEvent);

  useEffect(() => {
    const fetchArchivedEvent = async () => {
      if (!isViewArchivedEvent) return;

      try {
        setLoading(true);
        Swal.fire({
          text: "Please wait...",
          imageUrl: "https://www.finedge.in/assets/images/download.gif",
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });

        const response = await api.post(`advisor/getArchivedEvent`, { eventId: isViewArchivedEvent });

        setInitiatedFolios(response.data?.transactionForms);
        setArchivedEvent(response.data);
      } catch (err) {
        setArchivedEvent(null);
      } finally {
        setLoading(false);
        Swal.close();
      }
    };

    fetchArchivedEvent();
  }, [isViewArchivedEvent]);

  // Fetch initiated folios when roomId changes

  const getInitiatedFolios = async () => {
    setLoading(true);
    try {
      // Show Swal loader
      Swal.fire({
        text: "Please wait...",
        imageUrl: "https://www.finedge.in/assets/images/download.gif",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      const response = await api.post(
        `advisor/initiatedFolios/${roomId}`
      );

      const arrayResponse = Array.isArray(response.data)
        ? response.data
        : [response.data];
      console.log('arrayResponse', arrayResponse);

      if (!isViewArchivedEvent) {
        setInitiatedFolios(
          arrayResponse.map((item) => ({
            ...item,
            isChecked: true,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching initiated folios:", error);
    } finally {
      setLoading(false);
      Swal.close(); // Hide Swal loader
    }
  };
  useEffect(() => {
    if (roomId) {
      getInitiatedFolios();
    }
  }, [roomId]);

  
  const regenerateReInvestForm = async (data) => {
    return api.post("advisor/regenerate-reinvest-form", data);
  };

  // Calculate totals based on initiatedFolios
  useEffect(() => {
    if (initiatedFolios.length > 0) {
      const calculatedTotals = {
        totalAmount: 0,
        sipStart: 0,
        sipStop: 0,
        stpAmount: 0,
        redeemAmount: 0,
        lumpsumAmount: 0,
        sipStartTotal: 0,
        stpAmountTotal: 0,
        sipStopTotal: 0,
        redeemAmountTotal: 0,
        lumpsumAmountTotal: 0,
      };

      initiatedFolios?.forEach((folio) => {
        if (
          folio.tran_form_type === "SIP" &&
          folio.trans_status !== "Discarded"
        ) {
          calculatedTotals.sipStartTotal += folio.tran_no_of_unites || 0;
        }
        // Add more conditions for other types (e.g., STP, Lumpsum)
      });

      setTotals(calculatedTotals);
    }
  }, [initiatedFolios]);

  // Set goalEventId based on the first item of initiatedFolios
  useEffect(() => {
    if (initiatedFolios.length > 0) {
      setGoalEventId(initiatedFolios[0].pr_id);
    }
  }, [initiatedFolios]);

  console.log('groupedFoliosState', groupedFoliosState)

  useEffect(() => {
    if (!initiatedFolios || initiatedFolios.length === 0) return;

    let sipStartTotal = 0;
    let sipStopTotal = 0;
    let stpAmountTotal = 0;
    let redeemAmountTotal = 0;
    let lumpsumAmountTotal = 0;
    let archivableFlag = true;
    let isPostponedFlag = false;
    let eventId = null;

    initiatedFolios.forEach((folio) => {
      if (folio.eventId) eventId = folio.eventId;

      const isDiscarded = folio.trans_status === "Discarded";

      if (!isDiscarded) {
        switch (folio.tran_form_type) {
          case "SIP":
            sipStartTotal += Number(folio.tran_no_of_unites) || 0;
            console.log("ttl", sipStartTotal);

            break;

          case "ReInvest":
            lumpsumAmountTotal += Number(folio.tran_no_of_unites) || 0;
            break;

          case "Stop_sip":
            sipStopTotal += Number(folio.tran_no_of_unites) || 0;
            if (folio.trans_status === "Postponed") isPostponedFlag = true;
            break;

          case "STP":
            stpAmountTotal += Number(folio.tran_caluclate_amount) || 0;
            break;

          case "Redeem":
            redeemAmountTotal += Number(folio.tran_no_of_unites) || 0;
            break;
        }

        if (
          ["Processing", "Pending", "Failed", "Rejected"].includes(
            folio.trans_status
          )
        ) {
          archivableFlag = false;
        }
      }
    });

    // ✅ Update all totals in one go (no overwriting)
    setSipStartTotal(sipStartTotal);
    setSipStopTotal(sipStopTotal);
    setStpAmountTotal(stpAmountTotal);
    setRedeemAmountTotal(redeemAmountTotal);
    setLumpsumAmountTotal(lumpsumAmountTotal);
    setIsPostponed(isPostponedFlag);
    setIsEventId(eventId);
    setArchivable(archivableFlag);
  }, [initiatedFolios]);

  const handleRegenerate = async (item) => {
    if (!item?._id || !item?.client_id || !item?.pr_id) {
      Swal.fire({
        icon: "error",
        title: "Cannot regenerate",
        text: "Required transaction details are missing.",
      });
      return;
    }

    if (
      item.tran_form_type !== "ReInvest" ||
      String(item.trans_status || "").trim().toLowerCase() !== "processing"
    ) {
      return;
    }

    const confirmation = await Swal.fire({
      title: "Regenerate Lump Sum?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Continue",
      cancelButtonText: "Cancel",
    });

    if (!confirmation.isConfirmed) return;

    try {
      setRegeneratingId(item._id);

      const response = await regenerateReInvestForm({
        client_id: item.client_id,
        event_pr_id: item.pr_id,
        transaction_id: item._id,
      });

      if (response.data?.success) {
        await Swal.fire({
          icon: "success",
          title: "Request initiated",
          text:
            response.data.message ||
            "Lump Sum regeneration was initiated successfully.",
        });

        await getInitiatedFolios();
      } else {
        throw new Error(
          response.data?.message || "Regeneration could not be initiated."
        );
      }
    } catch (error) {
      console.error(
        "Regeneration failed:",
        error.response?.data || error
      );

      Swal.fire({
        icon: "error",
        title: "Regeneration failed",
        text:
          error.response?.data?.message ||
          error.message ||
          "Something went wrong while regenerating the transaction.",
      });
    } finally {
      setRegeneratingId(null);
    }
  };

  const getGoalMessage = (folios, goalName, goalYear) => {
    const selectedFolios = folios.filter((folio) => folio.isChecked);

    // --- Total Amount Calculation (same as PHP) ---
    const totalAmount = selectedFolios.reduce((sum, f) => {

      const d = Number(f.goal_folio_trans?.sipDeficit) || 0;
      const minus =
        (f.tran_form_type === "Redeem" || f.tran_form_type === "Stop_sip") &&
        f.trans_status !== "Discarded";
      return sum + (minus ? -d : d);
    }, 0);
    console.log('totalAmount', totalAmount);

    // Format INR and ensure absolute value for negative case
    const formattedAmount = formatRupees(Math.abs(totalAmount));

    // Check if it’s a "common goal" (for text “your” or not)
    const isCommonGoal =
      goalName.includes("Marriage") ||
      goalName.includes("Graduation") ||
      goalName.includes("Post Graduation");
    const yours =
      isCommonGoal || goalName.trim().split(" ").length <= 1 ? "" : " your";

    // --- Unmapped Goals ---
    if (goalName === "Unmapped Folio" || goalName === "Unmapped Folios") {
      return (
        <div className="alert alert-warning">
          <strong>Note:</strong> This folio is not mapped to any goal.
        </div>
      );
    }

    // --- Current Year Goals ---
    if (goalYear === new Date().getFullYear().toString()) {
      return (
        <div className="row bg-light">
          <div className="col-md-2">
            <img
              src="/assets/images/Goal-Event.svg"
              alt="Success"
              style={{ width: "6.2vw" }}
            />
          </div>
          <div className="col-md-10 pt-3">
            <p className="fs-14 fw-normal text-left w-100 mx-auto">
              <b>Congratulations,</b> you have successfully achieved{yours}{" "}
              <span className="fs-14 fw-semibold clrgreen">{goalName}</span> goal.
            </p>
          </div>
        </div>
      );
    }

    // --- Positive Impact (add) ---
    if (totalAmount > 0) {
      return (
        <div className="row">
          <div className="col-md-2">
            <img
              src="/assets/images/Goal-Event.svg"
              alt="Success"
              style={{ width: "6.2vw" }}
            />
          </div>
          <div className="col-md-10 pt-3">
            <p className="fs-14 fw-normal text-left w-100 mx-auto">
              This Goal Event will add a total of{" "}
              <span className="fs-14 fw-semibold clrgreen">
                {formattedAmount}
              </span>{" "}
              to{yours}{" "}
              <span className="fs-14 fw-semibold clrgreen">{goalName}</span> goal
              by the year{" "}
              <span className="fs-14 fw-semibold clrgreen">{goalYear}</span>.{" "}
              <b>Congratulations!</b>
            </p>
          </div>
        </div>
      );
    }

    // --- Negative Impact (subtract) ---
    if (totalAmount <= 0) {
      return (
        <div className="row bg-light">
          <div className="col-md-2">
            <img
              src="/assets/images/Goal-Event.svg"
              alt="Warning"
              style={{ width: "6.2vw" }}
            />
          </div>
          <div className="col-md-10 pt-3">
            <p className="fs-14 fw-normal text-left w-100 mx-auto">
              This Goal Event could potentially impact{yours}{" "}
              <span className="fs-14 fw-semibold clrgreen">{goalName}</span> goal
              by{" "}
              <span className="fs-14 fw-semibold clrgreen">
                {formattedAmount}
              </span>
              . But don't worry, there are plenty of tools and techniques
              available to cover this gap in the years to come! We’ll connect
              again soon to discuss an action plan for the same.
            </p>
          </div>
        </div>
      );
    }

    // --- Default Fallback ---
    return (
      <div className="alert alert-info">
        No specific details available for this goal.
      </div>
    );
  };

  //   const getGoalMessage = (folios, goalName, goalYear) => {
  //     console.log("goalYear",folios,goalYear,goalName);
  //     const selectedFolios = folios.filter((folio) => folio.isChecked);

  //     // const totalAmount = selectedFolios.reduce((sum, folio) => {
  //     //   const amt = folio.tran_form_type === "STP" ? folio.tran_caluclate_amount : folio.tran_no_of_unites;
  //     //   return sum + (Number(amt) || 0);
  //     // }, 0);

  //     const totalAmount = selectedFolios.reduce((sum, f) => {
  //   const d = Number(f.sipDeficit) || 0;
  //   const minus =
  //     (f.tran_form_type === "Redeem" || f.tran_form_type === "Stop_sip") &&
  //     f.trans_status !== "Discarded";
  //   return sum + (minus ? -d : d);
  // }, 0);


  //     const isCommonGoal =
  //       goalName.includes("Marriage") ||
  //       goalName.includes("Graduation") ||
  //       goalName.includes("Post Graduation");
  //     const yours =
  //       isCommonGoal || goalName.trim().split(" ").length <= 1 ? "" : " your";

  //      const formattedAmount = formatRupees(Math.abs(totalAmount))


  //     // Handle unmapped goals
  //     if (goalName === "Unmapped Folio" || goalName === "Unmapped Folios") {
  //       return (
  //         <div className="alert alert-warning">
  //           <strong>Note:</strong> This folio is not mapped to any goal.
  //         </div>
  //       );
  //     }

  //     // Handle current year goal achievement
  //     if (goalYear === new Date().getFullYear().toString()) {
  //       return (
  //         <div className="row bg-light">
  //           <div className="col-md-2">
  //             <img
  //               src="assets/images/Goal-Event.svg"
  //               alt="Success"
  //               style={{ width: "6.2vw" }}
  //             />
  //           </div>
  //           <div className="col-md-10 pt-3">
  //             <p className="fs-14 fw-normal text-left w-100 mx-auto">
  //               <b>Congratulations,</b> you have successfully achieved{yours}{" "}
  //               <span className="fs-14 fw-semibold clrgreen">{goalName}</span>{" "}
  //               goal.
  //             </p>
  //           </div>
  //         </div>
  //       );
  //     }

  //     if (totalAmount > 0) {
  //       return (
  //         <div className="row">
  //           <div className="col-md-2">
  //             <img
  //               src="assets/images/Goal-Event.svg"
  //               alt="Success"
  //               style={{ width: "6.2vw" }}
  //             />
  //           </div>
  //           <div className="col-md-10 pt-3">
  //             <p className="fs-14 fw-normal text-left w-100 mx-auto">
  //               This Goal Event could potentially add a total of{" "}
  //               <span className="fs-14 fw-semibold clrgreen">
  //                 {formattedAmount}
  //               </span>{" "}
  //               to{yours}{" "}
  //               <span className="fs-14 fw-semibold clrgreen">{goalName}</span>{" "}
  //               goal by the year{" "}
  //               <span className="fs-14 fw-semibold clrgreen">{goalYear}</span>.{" "}
  //               <b>Congratulations!</b>
  //             </p>
  //           </div>
  //         </div>
  //       );
  //     } else if (totalAmount < 0) {
  //       return (
  //         <div className="row bg-light">
  //           <div className="col-md-2">
  //             <img
  //               src="assets/images/Goal-Event.svg"
  //               alt="Warning"
  //               style={{ width: "6.2vw" }}
  //             />
  //           </div>
  //           <div className="col-md-10 pt-3">
  //             <p className="fs-14 fw-normal text-left w-100 mx-auto">
  //               This Goal Event could potentially impact{yours}{" "}
  //               <span className="fs-14 fw-semibold clrgreen">{goalName}</span>{" "}
  //               goal by{" "}
  //               <span className="fs-14 fw-semibold clrgreen">
  //                 {formattedAmount}
  //               </span>
  //               . But don't worry, there are plenty of tools and techniques
  //               available to cover this gap in the years to come! We’ll connect
  //               again soon to discuss an action plan for the same.
  //             </p>
  //           </div>
  //         </div>
  //       );
  //     }

  //     // Default fallback
  //     return (
  //       <div className="alert alert-info">
  //         No specific details available for this goal.
  //       </div>
  //     );
  //   };

  //   const showFundDetails = async (
  //     schemeCode,
  //     goalName,
  //     goalYear,
  //     fundName,
  //     startYear = new Date().getFullYear()
  //   ) => {
  //     setShowModal(true);
  //     setModalContent(
  //       `<p style="text-align:center;">Loading... <br><img src="/assets/images/download.gif" width="100"/></p>`
  //     );

  //     try {
  //       const res = await fetch(
  //         `advisor/get_fund_scheme?fund_name=${fundName}
  // `,
  //         {
  //           method: "post",
  //           headers: {
  //             "Content-Type": "application/x-www-form-urlencoded",
  //           },
  //           body: `schemeCode=${schemeCode}`,
  //         }
  //       );

  //       console.log("response", res);

  //       const data = await res.json();

  //       if (!data || data.length === 0) return;

  //       const fund = data;

  //       if (
  //         fund.Whitelisted !== "true" ||
  //         fund.Time_Horizon === "Temporary Parking"
  //       ) {
  //         const errorMsg =
  //           fund.Whitelisted === "false"
  //             ? "Fund snapshots are only available for whitelisted funds"
  //             : "Fund Snapshots not available for Temporary Parking Funds";
  //         setModalContent(
  //           `<p class="text-danger text-center mt-3">${errorMsg}</p>`
  //         );
  //         return;
  //       }

  //       const currentYear = new Date().getFullYear();
  //       const goalDuration = goalYear - startYear;
  //       let rtn2 =
  //         goalDuration <= 1
  //           ? "5 %"
  //           : goalDuration <= 3
  //             ? "8 %"
  //             : goalDuration <= 4.99
  //               ? "10 %"
  //               : goalDuration <= 6.99
  //                 ? "12 %"
  //                 : "14 %";

  //       let stmt2 = "";
  //       let rtnText = "";
  //       switch (fund.Time_Horizon) {
  //         case "1-3 Years":
  //           rtnText = "3 YEAR RETURN";
  //           stmt2 = "Short term focus is capital protection.";
  //           break;
  //         case "3-5 Years":
  //           rtnText = "5 YEAR RETURN";
  //           stmt2 = "Staggered entries work well here.";
  //           break;
  //         case "Above 5 Years":
  //           rtnText = "10 YEAR RETURN";
  //           stmt2 = "Invest monthly through SIPs or STPs.";
  //           break;
  //       }

  //       let SIRtn = fund.return_since_inception?.trim() || "Unavailable";

  //       if (!goalName?.toLowerCase().includes("goal")) goalName += " Goal";
  //       const goalName2 = ["marriage", "graduation"].some((g) =>
  //         goalName?.toLowerCase().includes(g)
  //       )
  //         ? goalName
  //         : "Your " + goalName;

  //       let riskProfile = fund.Risk_Profile?.replace(" Funds", "") || "";
  //       riskProfile = (riskProfile === "Aggressive" ? "an " : "a ") + riskProfile;

  //       const html = `
  //         <div style="max-height: 600px; overflow-y: auto; scrollbar-width: none; -ms-overflow-style: none;">
  //           <div class="row">
  //             <div class="col-sm-2 text-center"><img src="/assets/images/fund-scheme.png" style="width: 6vw;"></div>
  //             <div class="col-sm-8 text-dark pt-3 text-center">
  //               <div style="font-size:1.7vw;"><strong>${goalName} | Year ${goalYear}</strong></div>
  //               <div style="font-size: 1.3vw;">${fundName}</div>
  //             </div>
  //           </div><br>
  //           <div class="row text-center mb-3">
  //             <div class="col-sm-4 text-dark"><strong>FUND SIZE</strong><br><span class="text-success fs-5 fw-bold">${fund.fund_size
  //         }</span></div>
  //             <div class="col-sm-4 text-dark"><strong>INVESTMENT HORIZON</strong><br><span class="text-success fs-5 fw-bold">${fund.investment_horizon
  //         }</span></div>
  //             <div class="col-sm-4 text-dark"><strong>RETURN SINCE INCEPTION</strong><br><span class="text-success fs-5 fw-bold">${SIRtn}</span></div>
  //           </div>
  //           <div class="row d-flex justify-content-between text-center mb-3">
  //             <div class="col-sm-4 text-dark"><strong>CATEGORY</strong><br><span class="text-success fs-5 fw-bold">${fund.Sub_Category
  //         }</span></div>
  //             <div class="col-sm-4 text-dark"><strong>RETURN REQUIRED TO ACHIEVE GOAL</strong><br><span class="text-success fs-5 fw-bold">${rtn2}</span></div>
  //           </div>
  //           <hr>
  //           <div class="row">
  //             <div class="col-sm-8">
  //               <div style="background: #fff1e8;border: .7vw solid #ffd1d1;min-height: 14vw;">
  //                 <span class="fs-5 fw-bold text-success">RECOMMENDATION RATIONALE</span>
  //                 <ul class="small mt-2 ms-3 text-justify">
  //                   ${[
  //           fund.rationale1,
  //           fund.rationale2,
  //           fund.rationale3,
  //           fund.rationale4,
  //           fund.rationale5,
  //         ]
  //           .map((r) => `<li>${r}</li>`)
  //           .join("")}
  //                 </ul>
  //               </div>
  //             </div>
  //             <div class="col-sm-4">
  //               <span class="fs-5 fw-bold text-success">SUMMARY</span>
  //               <img src="/assets/images/fund_scheme_bulb.png" style="width: 3.5vw;">
  //               <hr>
  //               <p style="font-size: 1vw;">${goalName2} is ${goalYear - currentYear
  //         } years away. We recommend ${riskProfile} fund like ${fundName}. ${stmt2}</p>
  //             </div>
  //           </div>
  //           <div>
  //           <span class="fs-5 fw-bold text-success">OUR PHILOSOPHY</span>
  //           <ul class="small mt-2 ms-3 text-justify text-dark">
  //                   ${[
  //           fund.philosophy1,
  //           fund.philosophy2,
  //           fund.philosophy3,
  //           fund.philosophy4,
  //           fund.philosophy5,
  //         ]
  //           .map((r) => `<li>${r}</li>`)
  //           .join("")}
  //                 </ul>
  //           </div>
  //         </div>
  //       `;

  //       setModalContent(html);
  //     } catch (err) {
  //       console.error(err);
  //       setModalContent(
  //         `<p class="text-danger text-center mt-3">Something went wrong</p>`
  //       );
  //     }
  //   };


  const sendAdvisorToServer = useCallback(
    debounce(() => {
      socket.emit("advisor_pass", { room: roomId, refetch: true });
      console.log("advisor_pass", { room: roomId, refetch: true })
      getInitiatedFolios()
    }, 500),
    [roomId]
  );

  const handleFundDetailsModalClose = () => {
    socket.emit("show_snapshort", {
      room: roomId,
      show: false,
      data: {},
    });
    setShowModal(false)
    setModalContent("")
  }

  const showFundDetails = async (fundName, goalName, goalYea, startyear = new Date(), folio) => {
    console.log("folio", folio);

    let goalYear = folio?.goal_folio_trans?.goalYear || ""

    setShowModal(true);
    try {

      socket.emit("show_snapshort", {
        room: roomId,
        show: true,
        data: {
          fundName,
          goalName,
          goalYear,
          startyear,
        },
      });
      console.log("Emitted show_fund_details:", {
        fundName,
        goalName,
        goalYear,
        startyear,
      });
      const res = await api.post(
        `advisor/get_fund_by_name`,
        {
          fund_name: fundName,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await res.data;

      if (!data || data.length === 0) return;

      const fund = data;
      console.log(' andfundName ', fund, fundName, goalName);

      if (
        fund.Whitelisted !== "true" ||
        fund.Time_Horizon === "Temporary Parking"
      ) {
        const errorMsg =
          fund.Whitelisted === "false"
            ? "Fund snapshots are only available for whitelisted funds"
            : "Fund Snapshots not available for Temporary Parking Funds";
        setModalContent(
          `<p class="text-danger text-center mt-3">${errorMsg}</p>`
        );
        return;
      }

      const currentYear = new Date().getFullYear();
      const goalDuration = goalYear - moment(startyear).format("YYYY");

      let rtn2 =
        goalDuration <= 1 ? "6 %" : goalDuration <= 3 ? "8 %" : goalDuration <= 4.99 ? "10 %" : goalDuration <= 6.99
          ? "12 %"
          : "14 %";
      console.log('goalDuration', goalDuration, 'goalYear', goalYear, 'startyear', moment(startyear).format("YYYY"));

      let stmt2 = "";
      let rtnText = "";
      switch (fund.Time_Horizon) {
        case "1-3 Years":
          rtnText = "3 YEAR RETURN";
          stmt2 = "Short term focus is capital protection.";
          break;
        case "3-5 Years":
          rtnText = "5 YEAR RETURN";
          stmt2 = "Staggered entries work well here.";
          break;
        case "Above 5 Years":
          rtnText = "10 YEAR RETURN";
          // stmt2 = "Invest monthly through SIPs or STPs.";
          stmt2 = " A staggered approach through SIPs or STPs can help manage risk and enable disciplined investing and compounding over time.";
          break;
      }



      let SIRtn = fund.return_since_inception?.trim() || "Unavailable";

      if (!goalName?.toLowerCase().includes("goal")) goalName += " Goal";
      console.log("response 12 h", fund);

      const goalName2 = ["marriage", "graduation"].some((g) =>
        (goalName?.toLowerCase().includes(g))
          ? goalName
          : "Your " + goalName)
      console.log("response goalName2 12 ", goalName2);

      let riskProfile = fund.Risk_Profile?.replace(" Funds", "") || "";
      riskProfile = (riskProfile === "Aggressive" ? "an " : "a ") + riskProfile;

      console.log('riskProfile', riskProfile);





      let summry = "";
      const yearsAway = (goalYear || currentYear) - currentYear;

      // 1. Check for specific Sub_Category logic first
      switch (fund.Sub_Category) {
        case "Hybrid: Conservative Hybrid":
          summry = `Your ${goalName} is relatively short-term, and your risk appetite is moderate. We recommend a ${fundName} to prioritise stability, with a larger allocation to debt and limited equity exposure for measured growth.`;
          break;
        case "Hybrid: Equity Savings":
          summry = `Your ${goalName} is medium-term, and we recommend ${riskProfile === "a Very Aggressive" ? "aggressive" : riskProfile?.toLowerCase()} approach that combines stability with measured growth. We recommend the ${fundName}, which balances equity, arbitrage, and debt, aiming to deliver relatively stable outcomes with limited exposure to equity markets.`;
          break;
        case "Hybrid: Aggressive Hybrid":
          summry = `Your ${goalName} is medium to long-term, and your risk appetite allows for higher equity exposure. We recommend the ${fundName} to balance growth and stability by combining equity participation with a downside cushion from debt allocation.`;
          break;
        case "Hybrid Long-Short Fund":
          summry = `Your ${goalName} is short-term, and your risk appetite aligns with a more ${riskProfile === "a Very Aggressive" ? "aggressive" : riskProfile?.toLowerCase()} approach. We recommend the ${fundName} for its income-oriented strategy, which aims to provide relatively stable outcomes with lower volatility while maintaining flexibility across market conditions.`;
          break;
        case "Equity Long-Short Fund":
          summry = `Your ${goalName} is long-term, and your risk appetite allows for ${riskProfile === "a Very Aggressive" ? "aggressive" : riskProfile?.toLowerCase()} allocation to equity-oriented strategies. We recommend the Sapphire ${fundName} for its differentiated approach, which navigates market cycles by leveraging both long and short opportunities to manage risk and growth.`;
          break;
        case "Hybrid: Dynamic Asset Allocation":
          summry = `Your goal is medium to long term, and your preference is for a balanced investment approach. We recommend the ${fundName} that adjusts equity and debt exposure based on market conditions to help manage risk while aiming for steady growth. `;
          break;
      }

      // 2. Fallback to Category logic if no Sub_Category summary was set
      if (!summry) {
        if (fund.Category === "Equity") {
          summry = `Your ${goalName} is ${yearsAway} years away, and hence, we recommend  ${riskProfile === "a Very Aggressive" ? "aggressive" : riskProfile?.toLowerCase()} fund like ${fundName} to benefit from its long-term growth potential. ${stmt2}`;
        } else if (fund.Category === "Debt") {
          summry = `Your ${goalName} is short- to medium-term, and your priority is capital preservation. We recommend the ${fundName}, which focuses on generating stable income with relatively lower volatility than equity-oriented investments.`;
        }
      }


      // const html = `
      //     <div style="max-height: 800px; overflow-y: auto; scrollbar-width: none; -ms-overflow-style: none;">
      //       <div class="row">
      //         <div class="col-sm-2 text-center"><img src="/assets/images/fund-scheme.png" style="width: 6vw;"></div>
      //         <div class="col-sm-8 text-dark pt-3 text-center">
      //           <div style="font-size:1.7vw;"><strong>${goalName} | Year ${(goalYear || currentYear)
      //   }</strong></div>
      //           <div style="font-size: 1.3vw;">${fund.fund_name}</div>
      //         </div>
      //       </div><br>
      //       <div class="row text-center mb-3">
      //         <div class="col-sm-4 text-dark"><strong>FUND SIZE</strong><br><span class="text-success fs-5 fw-bold">${fund.AUM
      //   }</span></div>
      //         <div class="col-sm-4 text-dark"><strong>INVESTMENT HORIZON</strong><br><span class="text-success fs-5 fw-bold">${fund.investment_horizon
      //   }</span></div>
      //         <div class="col-sm-4 text-dark"><strong>RETURN SINCE INCEPTION</strong><br><span class="text-success fs-5 fw-bold">${SIRtn}</span></div>
      //       </div>
      //       <div class="row d-flex justify-content-between text-center mb-3">
      //         <div class="col-sm-4 text-dark"><strong>CATEGORY</strong><br><span class="text-success fs-5 fw-bold">${fund.Sub_Category
      //   }</span></div>
      //         <div class="col-sm-4 text-dark"><strong>RETURN REQUIRED TO ACHIEVE GOAL</strong><br><span class="text-success fs-5 fw-bold">${rtn2}</span></div>
      //       </div>
      //       <hr class="m-0">
      //       <div class="row">
      //         <div class="col-sm-8">
      //           <div style="background: #fff1e8;border: .7vw solid #ffd1d1;min-height: 14vw;">
      //             <span class="fs-5 fw-bold text-success">RECOMMENDATION RATIONALE</span>
      //             <ul class="small mt-2 ms-3 text-justify">
      //               ${[
      //     fund.rationale1,
      //     fund.rationale2,
      //     fund.rationale3,
      //     fund.rationale4,
      //     fund.rationale5,
      //   ]
      //     .map((r) => `<li>${r}</li>`)
      //     .join("")}
      //             </ul>
      //           </div>
      //         </div>
      //         <div class="col-sm-4">
      //           <span class="fs-5 fw-bold text-success">SUMMARY</span>
      //           <img src="/assets/images/fund_scheme_bulb.png" style="width: 3.5vw;">
      //           <p class="small">${summry}</p>
      //         </div>
      //       </div>
      //       <div>
      //       <span class="fs-5 fw-bold text-success">OUR PHILOSOPHY</span>
      //       <ul class="small mt-2 ms-3 text-justify text-dark">
      //               ${[
      //     fund.philosophy1,
      //     fund.philosophy2,
      //     fund.philosophy3,
      //     fund.philosophy4,
      //     fund.philosophy5,
      //   ]
      //     .map((r) => `<li>${r}</li>`)
      //     .join("")}
      //             </ul>
      //       </div>
      //     </div>
      //   `;

      const performanceCharacters = [
        fund.performance_character_1,
        fund.performance_character_2,
        fund.performance_character_3,
        fund.performance_character_4,
        fund.performance_character_5,
      ].filter(Boolean)

      const investmentApproach = [
        fund.investment_approach_1,
        fund.investment_approach_2,
        fund.investment_approach_3,
        fund.investment_approach_4,
        fund.investment_approach_5,
      ].filter(Boolean)

      const investmentStylePoints = [
        fund.investment_style_point_1,
        fund.investment_style_point_2,
        fund.investment_style_point_3,
        fund.investment_style_point_4,
      ].filter(Boolean)

      const behaviouralProfile = fund.behavioural_profile
        ? fund.behavioural_profile
            .split('\n')
            .filter(item => item.trim() !== '')
        : []

      const html = `
      <div style="background: #f5f7f4; font-family: Arial, sans-serif;">

        <!-- HEADER -->
        <div style="
            background: linear-gradient(135deg, #0d4f38, #0f5d3f);
            color: white;
            padding: 0.70rem 0.70rem;
            position: relative;
          ">

          <div class="row">

            <!-- LEFT -->
            <div class="col-sm-6">
              <div style="
                  font-size: 1.8rem;
                  font-weight: 300;
                  line-height: 1.15;
                  margin-bottom: 8px;
                ">
                ${goalName} | <span style="font-size: 1.1rem;font-weight: 200;line-height: 1.15;margin-bottom: 8px;">Target Year ${(goalYear || currentYear)}</span>
              </div>

              <div style="
                  font-size: 1.5rem;
                  font-weight: 500;
                  margin-bottom: 8px;
                ">
                ${fund.fund_name}
              </div>

              <div style="
                  font-size: .9rem;
                  opacity: .9;
                ">
                Category: ${fund.Category}
              </div>
            </div>

            <!-- RIGHT -->
            <div class="col-sm-6">

              <div class="row">

                <div class="col-6 mb-3">
                  <div style="
                      font-size: .75rem;
                      opacity: .8;
                      margin-bottom: 3px;
                    ">
                    FUND SIZE
                  </div>

                  <div style="
                      font-size: 1.6rem;
                      font-weight: 700;
                      white-space: nowrap;
                      line-height: 1.1;
                    ">
                    ₹${fund.AUM}
                  </div>
                </div>

                <div class="col-6 mb-3">
                  <div style="
                      font-size: .75rem;
                      opacity: .8;
                      margin-bottom: 3px;
                    ">
                    RETURNS SINCE INCEPTION
                  </div>

                  <div style="
                      font-size: 1.6rem;
                      font-weight: 700;
                      line-height: 1.1;
                    ">
                    ${SIRtn}%
                  </div>
                </div>

                <div class="col-6">
                  <div style="
                      font-size: .75rem;
                      opacity: .8;
                      margin-bottom: 3px;
                    ">
                    RETURN REQUIRED FOR GOAL
                  </div>

                  <div style="
                      font-size: 1.6rem;
                      font-weight: 700;
                      line-height: 1.1;
                    ">
                    ${rtn2}
                  </div>
                </div>

                <div class="col-6">
                  <div style="
                      font-size: .75rem;
                      opacity: .8;
                      margin-bottom: 3px;
                    ">
                    INVESTMENT HORIZON
                  </div>

                  <div style="
                      font-size: 1.6rem;
                      font-weight: 700;
                      line-height: 1.1;
                    ">
                    ${fund.investment_horizon} +
                  </div>
                </div>

              </div>

            </div>

          </div>

        </div>

        <!-- OBJECTIVE SECTION -->
        <div style="
            background: #eef3ee;
            padding: 10px 14px;
            border-bottom: 1px solid #dce5dc;
          ">

          <div class="row align-items-center">

            <div class="col-sm-3" style="
                border-right: 1px solid #d5dfd5;
              ">

              <div style="
                  color: #5b7c63;
                  font-size: .75rem;
                  font-weight: 600;
                ">
                PORTFOLIO ALLOCATION
              </div>

              <div style="
                  font-size: 0.85rem;
                  color: #1d1d1d;
                ">
                ${fund.portfolio_allocation || '-'}
              </div>

            </div>

            <div class="col-sm-9">

              <div style="
                  color: #5b7c63;
                  font-size: .75rem;
                  font-weight: 600;
                  margin-bottom: 4px;
                ">
                OBJECTIVE
              </div>

              <div style="
                  font-size: .85rem;
                  color: #222;
                  line-height: 1.5;
                ">
                ${fund.objective || '-'}
              </div>

            </div>

          </div>

        </div>

        <!-- MAIN CONTENT -->
        <div class="container-fluid" style="padding: 9px;">

          <div class="row">

            <!-- LEFT COLUMN -->
            <div class="col-md-4" style="border-right: 1px solid #d8e1d8;">

              <!-- ASSET MANAGER -->
              <div style="margin-bottom: 24px;">

                <div style="
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin-bottom: 12px;
                  ">

                  <div style="
                      width: 10px;
                      height: 10px;
                      background: #2d8a58;
                      border-radius: 50%;
                    "></div>

                  <div style="
                      color: #456a53;
                      font-size: 0.93rem;
                      letter-spacing: .5px;
                      font-weight: 600;
                    ">
                    ASSET MANAGER PROFILE
                  </div>

                </div>

                <p style="
                    color: #2f4235;
                    font-size: .85rem;
                    line-height: 1.6;
                    text-align: justify;
                  ">
                  ${fund.asset_manager_profile || '-'}
                </p>

              </div>

              <!-- BEHAVIOURAL PROFILE -->
              <div>

                <div style="
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin-bottom: 12px;
                  ">

                  <div style="
                      width: 10px;
                      height: 10px;
                      background: #2d8a58;
                      border-radius: 50%;
                    "></div>

                  <div style="
                      color: #456a53;
                      font-size: 0.93rem;
                      letter-spacing: .5px;
                      font-weight: 600;
                    ">
                    BEHAVIOURAL PROFILE
                  </div>

                </div>

                <ul style="
                    padding-left: 18px;
                    color: #2f4235;
                    line-height: 1.6;
                    font-size: .82rem;
                  ">
                  ${behaviouralProfile
                    .map(
                      (item) => `
                        <li>${item}</li>
                      `
                    )
                    .join("")}
                </ul>

              </div>

            </div>

            <!-- CENTER + RIGHT CONTENT -->
            <div class="col-md-8">

              <!-- TOP ROW -->
              <div class="row">

                <!-- PERFORMANCE CHARACTER -->
                <div class="col-md-6">

                  <div style="margin-bottom: 24px;">

                    <div style="
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        margin-bottom: 14px;
                      ">

                      <div style="
                          width: 10px;
                          height: 10px;
                          background: #2d8a58;
                          border-radius: 50%;
                        "></div>

                      <div style="
                          color: #456a53;
                          font-size: 0.93rem;
                          letter-spacing: .5px;
                          font-weight: 600;
                        ">
                        PERFORMANCE CHARACTER
                      </div>

                    </div>

                    ${performanceCharacters
                      .map(
                        (item) => `
                  <div style="
                      border-left: 3px solid #8bc69c;
                      background: #edf5ee;
                      padding: 4px 6px;
                      margin-bottom: 6px;
                      color: #3b5241;
                      line-height: 1.5;
                      font-size: .77rem;
                    ">
                    ${item}
                  </div>
                `
                      )
                      .join("")}

                  </div>

                </div>

                <!-- INVESTMENT APPROACH -->
                <div class="col-md-6">

                  <div style="
                      display: flex;
                      align-items: center;
                      gap: 8px;
                      margin-bottom: 14px;
                    ">

                    <div style="
                        width: 10px;
                        height: 10px;
                        background: #2d8a58;
                        border-radius: 50%;
                      "></div>

                    <div style="
                        color: #456a53;
                        font-size: 0.93rem;
                        letter-spacing: .5px;
                        font-weight: 600;
                      ">
                      INVESTMENT APPROACH
                    </div>

                  </div>

                  ${investmentApproach
                    .map(
                      (item) => `
                        <div style="
                            border: 1px solid #bdd4c0;
                            background: #f5faf5;
                            padding: 6px;
                            margin-bottom: 6px;
                            color: #334b39;
                            line-height: 1.5;
                            font-size: .77rem;
                          ">
                          ${item}
                        </div>
                      `
                    )
                    .join("")}

                </div>

              </div>

              <!-- FULL WIDTH INVESTMENT STYLE -->
              <div style="margin-top: 5px;">

                <div style="
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin-bottom: 6px;
                  ">

                  <div style="
                      width: 7px;
                      height: 7px;
                      background: #2d8a58;
                      border-radius: 50%;
                    "></div>

                  <div style="
                      color: #456a53;
                      font-size: 1rem;
                      letter-spacing: .5px;
                      font-weight: 600;
                    ">
                    INVESTMENT STYLE
                  </div>

                </div>

                <div style="
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    gap: 10px;
                    width: 100%;
                  ">

                  ${investmentStylePoints
                    .map(
                      (item, index) => `
                        <div style="
                            border: 1px solid #cddfcf;
                            background: #f7fbf7;
                            padding: 7px;
                            min-height: 90px;
                            display: flex;
                            flex-direction: column;
                            justify-content: flex-start;
                            width: 100%;
                          ">

                          <div style="
                              color: #aed0b5;
                              font-size: 1.5rem;
                              font-weight: 700;
                              margin-bottom: 5px;
                              line-height: 1;
                            ">
                            0${index + 1}
                          </div>

                          <div style="
                              color: #334d39;
                              line-height: 1.45;
                              font-size: .70rem;
                              flex-grow: 1;
                            ">
                            ${item}
                          </div>

                        </div>
                      `
                    )
                    .join("")}

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>
      `;

      setModalContent(html);
    } catch (err) {
      console.error(err);
      setModalContent(
        `<p class="text-danger text-center mt-3">Something went wrong</p>`
      );
    }
  };


  ////////////////////////////////
  // <p style="font-size: 1vw;">${goalName} is ${(goalYear || currentYear) - currentYear
  //        } years away. We recommend ${riskProfile} fund like ${fundName}. ${stmt2}</p>
  ///////////////////////////


  // useEffect(() => {
  //   // if (isConnected)

  //   socket.on("createCon", (msg) => {

  //     if(folios.length!==0){

  //     const selectedFolios = folios.filter((f) => f.isChecked);

  //     const selectedData = selectedFolios.map((f) => ({
  //       _id: f._id,
  //       status: f.trans_status,
  //     }));

  //     // console.log(" Selected Folio Data from Socket:", selectedData);

  //     // (Optional) Set state or handle them
  //     // if(!folios.length>0)
  //       setInitiatedFolios(folios);
  //       setSelectAll(msg.data?.selectAll)
  //     }

  //   });
  // }, []);
  useEffect(() => {
    socket.on("createCon", (msg) => {
      console.log("📥 Received from socket → createCon:", msg);
      const { type, payload } = msg.data || {};

      if (type === "checkbox-update") {
        const { goalName, transId, isChecked } = payload;

        setGroupedFoliosState((prev) => {
          const updated = { ...prev };
          if (!updated[goalName]) return prev;

          updated[goalName] = updated[goalName].map((folio) =>
            folio.transId === transId ? { ...folio, isChecked } : folio
          );
          return updated;
        });
      }

      if (type === "select-all-update") {
        const { goalName, isChecked } = payload;

        setGroupedFoliosState((prev) => {
          const updated = { ...prev };
          if (!updated[goalName]) return prev;

          updated[goalName] = updated[goalName].map((folio) => ({
            ...folio,
            isChecked,
          }));
          return updated;
        });
      }
    });
  }, []);

  useEffect(() => {
    socket.on("dataFetch", (msg) => {
      console.log("📥 Received from socket → dataFetch:", msg);
      const { isDiscard } = msg.data || {};
      if (isDiscard === true) {
        getInitiatedFolios()
        setSipStartTotal(0);
      }
    }, [])
  })


  const handleCheckboxChange = (goalName, transId, isChecked) => {
    setGroupedFoliosState((prev) => {
      const updated = { ...prev };
      updated[goalName] = updated[goalName].map((folio) =>
        folio.transId === transId ? { ...folio, isChecked } : folio
      );
      return updated;
    });
  };
  // Handle Select All checkbox toggle
  const handleSelectAll = (goalName, isChecked) => {
    setGroupedFoliosState((prev) => {
      const updated = { ...prev };
      updated[goalName] = updated[goalName].map((folio) => ({
        ...folio,
        isChecked,
      }));
      return updated;
    });
  };

  const regenerate = () => { };

  const handelShowFooter = (folio) => {
    const currentYear = new Date().getFullYear();
    const goalName = folio.goal_name || "";
    const goalYear = folio.goalYear || "0";
    let totalAmount = 5;

    // Calculate totalAmount based on transaction type and status
    if (
      folio.tran_form_type === "Redeem" ||
      folio.tran_form_type === "Stop_sip"
    ) {
      if (folio.trans_status !== "Discarded" && folio.sipDeficit) {
        totalAmount -= Number(folio.sipDeficit) || 0;
      }
    } else {
      if (folio.sipDeficit) {
        totalAmount += Number(folio.sipDeficit) || 0;
      }
    }
    console.log("totalAmount", totalAmount, goalYear);

    // Format totalAmount as INR currency
    const formattedAmount = formatRupees(Math.abs(totalAmount))

    // Determine the possessive form ("your" or "")
    const hasSpecialGoal =
      goalName.includes("Marriage") ||
      goalName.includes("Graduation") ||
      goalName.includes("Post Graduation");
    const yours = hasSpecialGoal ? "" : " your";

    // Handle unmapped folios
    if (goalName === "Unmapped Folio" || goalName === "Unmapped Folios") {
      return (
        <div className="alert alert-warning">
          <strong>Note:</strong> This folio is not mapped to any goal.
        </div>
      );
    }

    // Handle goals achieved in the current year
    if (parseInt(goalYear, 10) === currentYear) {
      return (
        <div className="row bg-light">
          <div className="col-md-2">
            <img
              src="/assets/images/Goal-Event.svg"
              alt="Success"
              style={{ width: "6.2vw" }}
            />
          </div>
          <div className="col-md-10 pt-3 ">
            <p className="fs-14 fw-normal text-left w-100 mx-auto">
              <b>Congratulations,</b> you have successfully achieved{yours}{" "}
              <span className="fs-14 fw-semibold clrgreen">{goalName}</span>{" "}
              goal.
            </p>
          </div>
        </div>
      );
    }

    // Handle positive or negative totalAmount
    if (totalAmount > 0) {
      return (
        <div className="row ">
          <div className="col-md-2">
            <img
              src="/assets/images/Goal-Event.svg"
              alt="Success"
              style={{ width: "6.2vw" }}
            />
          </div>
          <div className="col-md-10 pt-3">
            <p className="fs-14 fw-normal text-left w-100 mx-auto">
              This Goal Event could potentially add a total of{" "}
              <span className="fs-14 fw-semibold clrgreen">
                {formattedAmount}
              </span>{" "}
              to{yours}{" "}
              <span className="fs-14 fw-semibold clrgreen">{goalName}</span>{" "}
              goal by the year{" "}
              <span className="fs-14 fw-semibold clrgreen">{goalYear}</span>.{" "}
              <b>Congratulations!</b>
            </p>
          </div>
        </div>
      );
    } else if (totalAmount < 0) {
      return (
        <div className="row bg-light">
          <div className="col-md-2">
            <img
              src="/assets/images/Goal-Event.svg"
              alt="Warning"
              style={{ width: "6.2vw" }}
            />
          </div>
          <div className="col-md-10 pt-3">
            <p className="fs-14 fw-normal text-left w-100 mx-auto">
              This Goal Event could potentially impact{yours}{" "}
              <span className="fs-14 fw-semibold clrgreen">{goalName}</span>{" "}
              goal by{" "}
              <span className="fs-14 fw-semibold clrgreen">
                {formattedAmount}
              </span>
              . But don't worry, there are plenty of tools and techniques
              available to cover this gap in the years to come! We’ll connect
              again soon to discuss an action plan for the same.
            </p>
          </div>
        </div>
      );
    }

    // Default fallback
    return (
      <div className="alert alert-info">
        No specific details available for this goal.
      </div>
    );
  };

  const handleResend = () => {
    setShowResendModal(true);
  };

  const groupFoliosByGoal = (folios) => {
    const grouped = {};
    folios?.forEach((folio) => {
      if (!grouped[folio.goal_name]) {
        grouped[folio.goal_name] = [];
      }
      grouped[folio.goal_name].push(folio);
    });
    return grouped;
  };

  return (
    <>
      <div className="row">
        <div className="col">
          {initiatedFolios.length > 0 &&
            initiatedFolios?.[0]?.message !== "No initiated folios found." ? (
            <div className="scroll-container">
              {Object.entries(groupedFoliosState).map(([goalName, folios]) => {
                const stpFolios = folios.filter(
                  (f) => f.tran_form_type === "STP"
                );
                const lumpSumFolios = folios.filter(
                  (f) => f.tran_form_type === "ReInvest"
                );
                const sipFolios = folios.filter(
                  (f) => f.tran_form_type === "SIP"
                );
                const sipStopFolios = folios.filter(f => f.tran_form_type === "Stop_sip");


                const redeemFolios = folios.filter(f => f.tran_form_type === "Redeem");
                console.log("groupedFoliosState", sipFolios);

                // const lumpSumFolios = folios.filter(f => f.tran_form_type === "ReInvest");

                const stpTotal = stpFolios.reduce((acc, f) => acc + Number(f.tran_caluclate_amount || 0), 0);
                const lumpSumTotal = lumpSumFolios.reduce((acc, f) => acc + Number(f.tran_no_of_unites || 0), 0);
                const sipTotal = sipFolios.reduce((acc, f) => acc + Number(f.tran_no_of_unites || 0), 0);
                const redeemTotal = redeemFolios.reduce((acc, f) => acc + Number(f.tran_no_of_unites || 0), 0);
                const sipStopTotal = sipStopFolios.reduce((acc, f) => acc + Number(f.tran_no_of_unites || 0), 0);
                console.log("redeemTotal", redeemFolios, redeemTotal);

                const renderGoalMessageRow = (folios, goalName) => {
                  if (!folios || folios.length === 0) return null;

                  return (
                    <td colSpan="8">
                      {getGoalMessage(
                        folios,
                        goalName,
                        folios[0]?.goal_folio_trans?.goalYear || ""
                      )}
                    </td>
                  );
                };


                return (
                  <div key={goalName}>
                    <table className="table">
                      <thead>
                        <tr>
                          <th className="txt-color-revers sticky-header back-clrgreen">
                            Investor
                          </th>
                          <th className="txt-color-revers sticky-header back-clrgreen">
                            TXN Type
                          </th>
                          <th className="txt-color-revers sticky-header back-clrgreen">
                            Fund Name
                          </th>
                          <th className="txt-color-revers sticky-header back-clrgreen">
                            IFSC Code
                          </th>
                          <th className="txt-color-revers sticky-header back-clrgreen">
                            Account No.
                          </th>
                          <th className="txt-color-revers sticky-header back-clrgreen">
                            Amount
                          </th>
                          <th className="txt-color-revers sticky-header back-clrgreen">
                            <div className="fs-14 d-flex align-items-center gap-2">
                              <input
                                type="checkbox"
                                checked={folios.every((f) => f.isChecked)}
                              // onChange={(e) => handleSelectAll(goalName, e.target.checked)}
                              />
                              Status
                            </div>
                          </th>
                          <th className="txt-color-revers sticky-header back-clrgreen">
                            Remark
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {/* Goal header row */}
                        <tr className="bgblue">
                          <th colSpan="8">
                            <p className="fs-14 my-2">{goalName}</p>
                          </th>
                        </tr>
                        {stpFolios.length > 0 && (
                          <>
                            {/* <tr>
                <td colSpan="6" className="bg-light text-primary fw-bold">
                STP Transactions
                </td>
                </tr> */}

                            {stpFolios.map((folio, index) => (
                              <React.Fragment key={index}>
                                <tr>
                                  <td>{folio.investor_name}</td>
                                  <td>STP
                                    <OverlayTrigger
                                      placement="top"
                                      delay={{ show: 200, hide: 200 }}
                                      overlay={
                                        <Tooltip
                                          id={`tooltip-${index}`}
                                          style={{
                                            ['--bs-tooltip-max-width']: '520px',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >

                                          <div className="d-flex justify-content-left gap-2">
                                            <span className="fw-semibold">Start Date:</span>
                                            <span className="fw-normal">{moment(folio?.tran_start_date).format(
                                              "MMMM D, YYYY"
                                            )}</span>
                                          </div>
                                          <div className="d-flex justify-content-left gap-2">
                                            <span className="fw-semibold">Email Id:</span>
                                            <span className="fw-normal">{folio?.folio_email || "----"}</span>
                                          </div>



                                          <div className="d-flex justify-content-left gap-2">
                                            <span className="fw-semibold">Mobile:</span>
                                            <span className="fw-normal">{folio?.folio_mobile || "----"}</span>
                                          </div>
                                          <div className="d-flex justify-content-left gap-2">
                                            <span className="fw-semibold">Client Code:</span>
                                            <span className="fw-normal">{folio?.client_ucc + " (" + folio.tran_mandate_ID + ") " || "----"}</span>
                                          </div>

                                          <div className="d-flex justify-content-left gap-2">
                                            <span className="fw-semibold">Account No:</span>
                                            <span className="fw-normal">
                                              {folio?.account_number
                                                ? `${"*".repeat(folio.account_number.length - 4)}${folio.account_number.slice(-4)}`
                                                : "****"}
                                            </span>
                                          </div>
                                        </Tooltip>
                                      }
                                    >
                                      <span className="clrgreen ms-1" style={{ cursor: "pointer" }}>
                                        <IoInformationCircleOutline />
                                      </span>
                                    </OverlayTrigger>
                                  </td>
                                  <td>
                                    {folio.tran_fund_name || folio.tran_out_fund}
                                    <span className="clrgreen ms-1" style={{ cursor: "pointer" }}>
                                      <IoInformationCircleOutline
                                        className="ms-2"
                                        onClick={() => showFundDetails(folio.tran_fund_name, goalName, folio.goalYear, folio.startYear, folio)}
                                        style={{ cursor: "pointer" }}
                                      />
                                    </span>
                                  </td>

                                  <td>{folio?.ifsc_code || folio?.goal_folio_trans?.ifsc_code || '--'}</td>
                                  <td>{folio?.account_number || '--'}</td>

                                  <td>{formatRupees(folio.tran_caluclate_amount)}</td>
                                  
                                  <td>
                                    <div className="d-flex align-items-center gap-2 flex-wrap">
                                      <label className="container1" style={{ margin: 0 }}>
                                        <input
                                          type="checkbox"
                                          checked={folio.isChecked || false}
                                          readOnly
                                        />
                                        <span className="checkmark"></span>
                                      </label>

                                      <span>{folio.trans_status}</span>

                                    </div>
                                  </td>
                                  <td>
                                    {folio.trans_status === "Executed"
                                      ? "ALLOTMENT DONE"
                                      : folio.bse_response}
                                  </td>
                                </tr>
                              </React.Fragment>
                            ))}

                            <tr>
                              <td colSpan="5" className="text-end fw-semibold">
                                STP Total:
                              </td>
                              <td>{formatRupees(stpTotal)}</td>
                              <td colSpan="2"></td>
                            </tr>
                          </>
                        )}
                        
                        {lumpSumFolios.length > 0 && (
                          <>
                            {lumpSumFolios.map((folio, index) => {
                              return (
                                <React.Fragment key={folio._id || index}>
                                  <tr>
                                    <td>{folio.investor_name}</td>

                                    <td>
                                      Lump Sum{" "}
                                      <OverlayTrigger
                                        placement="top"
                                        delay={{ show: 200, hide: 200 }}
                                        overlay={
                                          <Tooltip
                                            id={`tooltip-${index}`}
                                            style={{
                                              ["--bs-tooltip-max-width"]: "520px",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            <div className="d-flex justify-content-left gap-2">
                                              <span className="fw-semibold">Start Date:</span>
                                              <span className="fw-normal">
                                                {moment(folio?.created_at).format("MMMM D, YYYY")}
                                              </span>
                                            </div>

                                            <div className="d-flex justify-content-left gap-2">
                                              <span className="fw-semibold">Email Id:</span>
                                              <span className="fw-normal">
                                                {folio?.folio_email || "----"}
                                              </span>
                                            </div>

                                            <div className="d-flex justify-content-left gap-2">
                                              <span className="fw-semibold">Mobile:</span>
                                              <span className="fw-normal">
                                                {folio?.folio_mobile || "----"}
                                              </span>
                                            </div>

                                            <div className="d-flex justify-content-left gap-2">
                                              <span className="fw-semibold">Client Code:</span>
                                              <span className="fw-normal">
                                                {folio?.client_ucc
                                                  ? `${folio.client_ucc} (${folio.tran_mandate_ID || "----"})`
                                                  : "----"}
                                              </span>
                                            </div>

                                            <div className="d-flex justify-content-left gap-2">
                                              <span className="fw-semibold">Account No:</span>
                                              <span className="fw-normal">
                                                {folio?.account_number
                                                  ? `${"*".repeat(
                                                      Math.max(0, folio.account_number.length - 4)
                                                    )}${folio.account_number.slice(-4)}`
                                                  : "****"}
                                              </span>
                                            </div>
                                          </Tooltip>
                                        }
                                      >
                                        <span
                                          className="clrgreen ms-1"
                                          style={{ cursor: "pointer" }}
                                        >
                                          <IoInformationCircleOutline />
                                        </span>
                                      </OverlayTrigger>
                                    </td>

                                    <td>
                                      {folio.tran_fund_name}
                                      <span
                                        className="clrgreen ms-1"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <IoInformationCircleOutline
                                          className="ms-2"
                                          onClick={() =>
                                            showFundDetails(
                                              folio.tran_fund_name,
                                              goalName,
                                              folio.goalYear,
                                              folio.startYear,
                                              folio
                                            )
                                          }
                                          style={{ cursor: "pointer" }}
                                        />
                                      </span>
                                    </td>

                                    <td>
                                      {folio?.ifsc_code ||
                                        folio?.goal_folio_trans?.ifsc_code ||
                                        "--"}
                                    </td>

                                    <td>{folio?.account_number || "--"}</td>

                                    <td>{formatRupees(folio.tran_no_of_unites)}</td>

                                    <td>
                                      <div
                                        className="d-flex align-items-center gap-2"
                                        style={{
                                          flexWrap: "nowrap",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        <label
                                          className="container1"
                                          style={{ margin: 0, flexShrink: 0 }}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={folio.isChecked || false}
                                            readOnly
                                          />
                                          <span className="checkmark"></span>
                                        </label>

                                        <span>{folio.trans_status}</span>

                                        {folio.tran_form_type === "ReInvest" &&
                                          String(folio.trans_status || "").trim().toLowerCase() ===
                                          "processing" && (
                                            <span
                                              title="Regenerate Lump Sum transaction"
                                              role="button"
                                              tabIndex={0}
                                              aria-label="Regenerate Lump Sum transaction"
                                              style={{
                                                cursor:
                                                  regeneratingId === folio._id
                                                    ? "not-allowed"
                                                    : "pointer",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexShrink: 0,
                                                opacity: regeneratingId === folio._id ? 0.5 : 1,
                                                marginLeft: "4px",
                                              }}
                                              onClick={() => {
                                                if (regeneratingId !== folio._id) {
                                                  handleRegenerate(folio);
                                                }
                                              }}
                                              onKeyDown={(e) => {
                                                if (e.key === "Enter" || e.key === " ") {
                                                  e.preventDefault();

                                                  if (regeneratingId !== folio._id) {
                                                    handleRegenerate(folio);
                                                  }
                                                }
                                              }}
                                            >
                                              <TfiReload color="red" size={18} />
                                            </span>
                                          )}
                                      </div>
                                    </td>

                                    <td>
                                      {folio.trans_status === "Executed"
                                        ? "ALLOTMENT DONE"
                                        : folio.bse_response}
                                    </td>
                                  </tr>
                                </React.Fragment>
                              );
                            })}

                            <tr>
                              <td colSpan="5" className="text-end fw-semibold">
                                Lump Sum Total:
                              </td>
                              <td>{formatRupees(lumpSumTotal)}</td>
                              <td colSpan="2"></td>
                            </tr>
                          </>
                        )}
                        {sipFolios.length > 0 && (
                          <>
                            {sipFolios.map((folio, index) => (
                              <React.Fragment key={index}>
                                <tr>
                                  <td>{folio.investor_name}</td>
                                  <td>SIP  <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 200, hide: 200 }}
                                    overlay={
                                      <Tooltip
                                        id={`tooltip-${index}`}
                                        style={{
                                          ['--bs-tooltip-max-width']: '520px',
                                          whiteSpace: 'nowrap',
                                        }}
                                      >
                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Start Date:</span>
                                          <span className="fw-normal">{moment(folio?.tran_start_date).format(
                                            "MMMM D, YYYY"
                                          )}</span>
                                        </div>
                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Email Id:</span>
                                          <span className="fw-normal">{folio?.folio_email || "----"}</span>
                                        </div>



                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Mobile:</span>
                                          <span className="fw-normal">{folio?.folio_mobile || "----"}</span>
                                        </div>
                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Client Code:</span>
                                          <span className="fw-normal">{folio?.client_ucc + " (" + folio.tran_mandate_ID + ") " || "----"}</span>
                                        </div>

                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Account No:</span>
                                          <span className="fw-normal">
                                            {folio?.account_number
                                              ? `${"*".repeat(folio.account_number.length - 4)}${folio.account_number.slice(-4)}`
                                              : "****"}
                                          </span>
                                        </div>
                                      </Tooltip>

                                    }
                                  >
                                    <span className="clrgreen ms-1" style={{ cursor: "pointer" }}>
                                      <IoInformationCircleOutline />
                                    </span>
                                  </OverlayTrigger></td>
                                  <td>{folio.tran_fund_name}
                                    <span className="clrgreen ms-1" style={{ cursor: "pointer" }}>
                                      <IoInformationCircleOutline
                                        className="ms-2"
                                        onClick={() => showFundDetails(folio.tran_fund_name, goalName, folio.goalYear, folio.startYear, folio)}
                                        style={{ cursor: "pointer" }}
                                      />
                                    </span>
                                  </td>
                                  <td>{folio?.ifsc_code || folio?.goal_folio_trans?.ifsc_code || '--'}</td>
                                  <td>{folio?.account_number || '--'}</td>
                                  <td>

                                    {formatRupees(folio.tran_no_of_unites)}

                                  </td>
                                  <td >
                                    <div className="d-flex align-items-center gap-2">
                                      <label
                                        className="container1"
                                        style={{ margin: 0 }}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={folio.isChecked || false}
                                        // onChange={(e) =>
                                        //   handleCheckboxChange(goalName, folio.transId, e.target.checked)
                                        // }
                                        />
                                        <span className="checkmark"></span>
                                      </label>
                                      {folio.trans_status}
                                    </div>
                                  </td>
                                  <td>
                                    {folio.trans_status === "Executed"
                                      ? "ALLOTMENT DONE"
                                      : folio.bse_response}
                                  </td>
                                </tr>
                              </React.Fragment>
                            ))}
                            <tr>
                              <td colSpan="5" className="text-end fw-semibold">
                                Sip Total:
                              </td>
                              <td>{formatRupees(sipTotal)}</td>
                              <td colSpan="2"></td>
                            </tr>
                          </>
                        )}
                        {sipStopFolios.length > 0 && (
                          <>

                            {sipStopFolios.map((folio, index) => (
                              <React.Fragment key={index}>
                                <tr>
                                  <td>{folio.investor_name}</td>
                                  <td> SIP Stop <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 200, hide: 200 }}
                                    overlay={
                                      <Tooltip
                                        id={`tooltip-${index}`}
                                        style={{
                                          ['--bs-tooltip-max-width']: '520px',
                                          whiteSpace: 'nowrap',
                                        }}
                                      >

                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Start Date:</span>
                                          <span className="fw-normal">{moment(folio?.tran_start_date).format(
                                            "MMMM D, YYYY"
                                          )}</span>
                                        </div>
                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Email Id:</span>
                                          <span className="fw-normal">{folio?.folio_email || "----"}</span>
                                        </div>



                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Mobile:</span>
                                          <span className="fw-normal">{folio?.folio_mobile || "----"}</span>
                                        </div>
                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Client Code:</span>
                                          <span className="fw-normal">{folio?.client_ucc + " (" + folio.tran_mandate_ID + ") " || "----"}</span>
                                        </div>

                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Account No:</span>
                                          <span className="fw-normal">
                                            {folio?.account_number
                                              ? `${"*".repeat(folio.account_number.length - 4)}${folio.account_number.slice(-4)}`
                                              : "****"}
                                          </span>
                                        </div>
                                      </Tooltip>
                                    }
                                  >
                                    <span className="clrgreen ms-1" style={{ cursor: "pointer" }}>
                                      <IoInformationCircleOutline />
                                    </span>
                                  </OverlayTrigger></td>
                                  <td>{folio.tran_fund_name}


                                    <span className="clrgreen ms-1" style={{ cursor: "pointer" }}>
                                      <IoInformationCircleOutline
                                        className="ms-2"
                                        onClick={() => showFundDetails(folio.tran_fund_name, goalName, folio.goalYear, folio.startYear, folio)}
                                        style={{ cursor: "pointer" }}
                                      />
                                    </span>
                                  </td>
                                  <td>{folio?.ifsc_code || folio?.goal_folio_trans?.ifsc_code || '--'}</td>
                                  <td>{folio?.account_number || '--'}</td>
                                  <td>{formatRupees(folio.tran_no_of_unites)}</td>
                                  <td className="d-flex align-items-center gap-2">
                                    <label className="container1" style={{ margin: 0 }}>
                                      <input
                                        type="checkbox"
                                        checked={folio.isChecked || false}
                                      // onChange={(e) =>
                                      //   handleCheckboxChange(goalName, folio.transId, e.target.checked)
                                      // }
                                      />
                                      <span className="checkmark"></span>
                                    </label>
                                    {folio.trans_status}
                                  </td>
                                  <td>{folio.trans_status === "Executed" ? "ALLOTMENT DONE" : folio.bse_response}</td>
                                </tr>
                              </React.Fragment>
                            ))}

                            <tr>
                              <td colSpan="5" className="text-end fw-semibold">Sip Stop Total:</td>
                              <td>{formatRupees(sipStopTotal)}</td>
                              <td colSpan="2"></td>
                            </tr>
                          </>
                        )}

                        {redeemFolios?.length > 0 && (
                          <>
                            {redeemFolios?.map((folio, index) => (
                              <React.Fragment key={index}>
                                <tr>
                                  <td>{folio.investor_name}</td>
                                  <td>Redeem  <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 200, hide: 200 }}
                                    overlay={
                                      <Tooltip
                                        id={`tooltip-${index}`}
                                        style={{
                                          ['--bs-tooltip-max-width']: '520px',
                                          whiteSpace: 'nowrap',
                                        }}
                                      >

                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Start Date:</span>
                                          <span className="fw-normal">{moment(folio?.tran_start_date).format(
                                            "MMMM D, YYYY"
                                          )}</span>
                                        </div>
                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Email Id:</span>
                                          <span className="fw-normal">{folio?.folio_email || "----"}</span>
                                        </div>



                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Mobile:</span>
                                          <span className="fw-normal">{folio?.folio_mobile || "----"}</span>
                                        </div>
                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Client Code:</span>
                                          <span className="fw-normal">{folio?.client_ucc + " (" + folio.tran_mandate_ID + ") " || "----"}</span>
                                        </div>

                                        <div className="d-flex justify-content-left gap-2">
                                          <span className="fw-semibold">Account No:</span>
                                          <span className="fw-normal">
                                            {folio?.account_number
                                              ? `${"*".repeat(folio.account_number.length - 4)}${folio.account_number.slice(-4)}`
                                              : "****"}
                                          </span>
                                        </div>
                                      </Tooltip>
                                    }
                                  >
                                    <span className="clrgreen ms-1" style={{ cursor: "pointer" }}>
                                      <IoInformationCircleOutline />
                                    </span>
                                  </OverlayTrigger></td>
                                  <td>{folio.tran_fund_name}

                                    <span className="clrgreen ms-1" style={{ cursor: "pointer" }}>
                                      <IoInformationCircleOutline
                                        className="ms-2"
                                        onClick={() => showFundDetails(folio.tran_fund_name, goalName, folio.goalYear, folio.startYear, folio)}
                                        style={{ cursor: "pointer" }}
                                      />
                                    </span>
                                  </td>
                                  <td>{folio?.ifsc_code || folio?.goal_folio_trans?.ifsc_code || '--'}</td>
                                  <td>{folio?.account_number || '--'}</td>
                                  <td>{formatRupees(folio.tran_no_of_unites)}</td>
                                  <td >
                                    <div className="d-flex align-items-center gap-2">
                                      <label className="container1" style={{ margin: 0 }}>
                                        <input
                                          type="checkbox"
                                          checked={folio.isChecked || false}
                                        // onChange={(e) =>
                                        //   handleCheckboxChange(goalName, folio.transId, e.target.checked)
                                        // }
                                        />
                                        <span className="checkmark"></span>
                                      </label>
                                      {folio.trans_status}
                                    </div>
                                  </td>
                                  <td>{folio.trans_status === "Executed" ? "ALLOTMENT DONE" : folio.bse_response}</td>
                                </tr>
                              </React.Fragment>
                            ))}

                            <tr>
                              <td colSpan="5" className="text-end fw-semibold">Redeem Total:</td>
                              <td>{formatRupees(redeemTotal)}</td>
                              <td colSpan="2"></td>
                            </tr>
                          </>
                        )}


                        {/* Footer Message Row (replaces handelShowFooter) */}

                        <tr>{renderGoalMessageRow(folios, goalName)}</tr>
                      </tbody>
                    </table>
                  </div>
                );
              })}
            </div>
          ) : (
            <Alert
              variant="success"
              className="fw-bold d-block text-center mt-4"
            >
              {
                loading ? "Loading..." : "No Goal Event"
              }

            </Alert>
          )}
        </div>
      </div>
      {isPostponed && (
        <div className="mt-3">
          <div className=" alert alert-warning ">
            Alert! Some SIP Stops will be processed after the next
            debit as less than 9 days remain until the next debit
            date.
          </div>
        </div>
      )}
      {!isViewArchivedEvent && (
        <div class="row pt-3">
          <div class="col text-end">
            <p class="fs-14 fw-normal Total">
              <div className="d-flex gap-4 justify-content-end">
                {sipStartTotal !== 0 && (
                  <p>
                    SIP Start{" "}
                    <span class="fs-14 fw-semibold">{formatRupees(sipStartTotal)}</span>
                  </p>
                )}
                {lumpsumAmountTotal !== 0 && (
                  <p>
                    Lump Sum Amount{" "}
                    <span class="fs-14 fw-semibold">
                      {formatRupees(lumpsumAmountTotal)}
                    </span>
                  </p>
                )}
                {sipStopTotal !== 0 && (
                  <p>
                    SIP Stop{" "}
                    <span class="fs-14 fw-semibold">{formatRupees(sipStopTotal)}</span>
                  </p>
                )}
                {redeemAmountTotal !== 0 && (
                  <p>
                    Redemption Amount{" "}
                    <span class="fs-14 fw-semibold">{formatRupees(redeemAmountTotal)}</span>
                  </p>
                )}
                {stpAmountTotal !== 0 && (
                  <p>
                    STP Amount{" "}
                    <span class="fs-14 fw-semibold">{formatRupees(stpAmountTotal)}</span>
                  </p>
                )}


              </div>


              {initiatedFolios.length > 0 ? (
                (initiatedFolios[0].eventStatus == "Failed" ||
                  initiatedFolios[0].eventStatus == "Rejected") && (
                  <button
                    class="btndesignactive  rounded-pill mx-3 mt-md-0 mt-3"
                    onClick={handleResend}
                  >
                    <span>RESEND </span> <RxCross2 className="fs-5" />
                  </button>
                )
              ) : (
                <></>
                // <div className="alert alert-danger">No open Goal Event</div>
              )}
              {/* <span>
                            <button class="btndesign pt-3 border border-1  rounded-pill mx-3">
                            <p>
                            Discard{" "}
                            <span>
                            <img src="assets/images/wrong.svg" alt="" class="wrong" />
                            </span>
                            </p>
                            </button>
                            </span>
                            <span>
                            <button class="btndesignactive clr active pt-3">
                            <p>
                            Execute{" "}
                            <span>
                            <img src="assets/images/right.png" alt="" />
                            </span>
                            </p>
                            </button>
                            </span> */}
            </p>
          </div>
        </div>
      )}

      <ResendModal
        sendAdvisorToServer={sendAdvisorToServer}
        show={showResendModal}
        onHide={() => setShowResendModal(false)}
        roomId={roomId}
        isEventId={isEventId}
      />

      <ReferAFriendModal
        show={showReferFriendModal}
        onHide={() => setShowReferFriendModal(false)}
        roomId={roomId}
      />

      <FundDetailsModal
        show={showModal}
        onHide={() => handleFundDetailsModalClose()}
        content={modalContent}
      />
    </>
  );
};
